import React from 'react';

import NavigationIcon, {
	NavigationIconType,
} from '~/components/patterns/icons/NavigationIcon';



type Props = {
	onSearchClick: () => void,
	onWebsitesClick: () => void,
};

/**
 * Compact layout for Technical section in Phase 2 (responsive-mobile)
 *
 * Displays reduced icon versions of websites dropdown and search functionality
 * when Technical section is expanded in Phase 2 view.
 *
 * This layout appears between AccountNavButton and secondary navigation items.
 */
const TechnicalPhase2CompactLayout: React.FC<Props> = (props) => {
	const {
		onSearchClick,
		onWebsitesClick,
	} = props;

	return (
		<>
			{/* First divider - separates from AccountNavButton */}
			<li className="main-nav__divider main-nav__divider--phase2-compact" />

			{/* Websites dropdown icon button */}
			<li className="main-nav__item main-nav__item--phase2-compact">
				<button
					aria-label="Expand websites dropdown"
					className="main-nav__phase2-compact-button"
					onClick={onWebsitesClick}
					type="button"
				>
					<NavigationIcon
						color="#89c32e"
						size={20}
						type={NavigationIconType.Websites}
					/>
				</button>
			</li>

			{/* Search icon button */}
			<li className="main-nav__item main-nav__item--phase2-compact">
				<button
					aria-label="Search"
					className="main-nav__phase2-compact-button"
					onClick={onSearchClick}
					type="button"
				>
					<NavigationIcon
						color="#f3f3f3"
						size={20}
						type={NavigationIconType.Search}
					/>
				</button>
			</li>

			{/* Second divider - separates from secondary navigation items */}
			<li className="main-nav__divider main-nav__divider--phase2-compact" />
		</>
	);
};



export default TechnicalPhase2CompactLayout;
